/*
 Create by smg  2015-12-23
 */
"use strict";
angular.module("productManageMentAppColumnModule", [
        'mangeAppProColumnCtrlModule',
        'productManageMentAppColumnRecycleBinModule',
        'productManageMentAppColumnRouterModule'
    ])
    .controller("productManageMentAppColumnCtrl", ['$scope', '$rootScope', '$q', '$state', '$modal', '$stateParams', 'trsHttpService', "websiteService", "modalDialog", "productMangageMentAppService", "localStorageService", "trsspliceString", function($scope, $rootScope, $q, $state, $modal, $stateParams, trsHttpService, websiteService, modalDialog, productMangageMentAppService, localStorageService, trsspliceString) {
        initStatus();
        initData();
        /**
         * [getChannelPath description]获得栏目的全路径
         * @return {[type]} [description]
         */
        function getChannelPath() {
            var params = {
                "serviceid": "mlf_mediasite",
                "methodname": "getChannelIdPath",
                "ChannelId": $stateParams.channel,
                "Burster": ">"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.channelPath = data;
                if (data.length > 0) {
                    $scope.data.siteName = data[0].SITENAME;
                    $scope.data.siteId = data[0].SITEID;
                }
            });
        }
        /**
         * [positionToChannel description]定位到站点
         * @return {[type]} [description]
         */
        $scope.positionToSite = function() {
            $state.go("manageconfig.productmanage.app.channel", { site: $scope.data.siteId }, { reload: true });
        };
        /**
         * [positionToChannel description]定位到栏目
         * @return {[type]} [description]
         */
        $scope.positionToChannel = function(chnnel) {
            $state.go("manageconfig.productmanage.app.column", { site: $scope.data.siteId, channel: chnnel.CHANNELID }, { reload: true });
        };
        //初始化数据
        //获取栏目操作权限开始
        function getChnlRights() {
            productMangageMentAppService.getRight("", $stateParams.parentchnl, "appsetchannel.channel").then(function(data) {
                $scope.status.right = data;
            });
        }
        /**
         * [clickSiteDirected description]点击站点重定向开始
         * @return null [description]
         */
        $scope.clickChnlDirected = function(item) {
            productMangageMentAppService.getCloumnAccessAuthority($stateParams.parentchnl).then(function(data) {
                //將权限信息存入缓存，用于底部路由区加载使用开始
                localStorageService.set("appRightOperType", {
                    type: data.router,
                    data: data.data
                });
                //$rootScope.$broadcast("expandAppLeftTree", "column");
                //將权限信息存入缓存，用于底部路由区加载使用结束
                $state.go("manageconfig.productmanage.app.column", {
                    channel: item.CHANNELID,
                    parentchnl: $stateParams.parentchnl,
                    status: item.STATUS
                }, { reload: true });
            });
            //將权限信息存入缓存，用于底部路由区加载使用结束
            // $state.go("manageconfig.productmanage.app.column", {
            //     channel: item.CHANNELID,
            //     parentchnl: $stateParams.parentchnl
            // });
        };
        //获取栏目操作权限结束
        function initData() {
            requestData().then(function(data) {
                $scope.appItems = data;
                $scope.appItems !== "" ? $scope.selectedColumn = $scope.appItems[0] : "";
                initChannel();
            });
            getChannelPath();
        }
        //数据请求函数
        function requestData() {
            var defferd = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                defferd.resolve(data);
            });
            return defferd.promise;
        }
        $scope.enderInColumn = function(appItem) {
            $scope.selectedColumn = appItem;
        };
        //搜索栏目
        $scope.searchColumn = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.serviceid = "mlf_appconfig";
                $scope.params.methodname = "queryChannelsByChannelForCloud";
                $scope.params.ChannelId = $stateParams.channel;
                $scope.params.ChnlDesc = $scope.searchColumnByName;
                requestData().then(function(data) {
                    $scope.appItems = data;
                });
            }
        };
        //鼠标移入
        $scope.getInSelectedChl = function(appItem) {
            $scope.selectedColumn = appItem;
        };

        function initStatus() {
            $scope.status = {
                PmmAppChnlSelected: $stateParams.appselect,
                right: {},
                selectedArray: [],
                status:$stateParams.status,
                statusOptions: [{
                    name: "全部状态",
                    value:null
                }, {
                    name: "启用",
                    value: 0,
                }, {
                    name: "停用",
                    value: -1
                }]
            };
            $scope.status.selectStatus=$scope.status.statusOptions[0];
            $scope.params = {
                serviceid: "mlf_appconfig",
                methodname: "queryChannelsByChannelForCloud",
                ChannelId: $stateParams.channel,
                status:null
            };
            $scope.data = {
                channelPath: "",
            };
            $scope.superiorChn = $stateParams.channel;
            getChnlRights();
        };
        /**
         * [selectStatus description]根据状态筛选频道
         * @params [{appItem}] [description]
         * @return null [description]
         */
        $scope.selectStatus = function() {            
            $scope.params.status = $scope.status.selectStatus.value;           
            requestData().then(function(data) {
                    $scope.appItems = data;
                });
        };
        /**
         * [selectAll description]全选
         * @params [{}] [description]
         * @return null [description]
         */
        $scope.selectAll = function() {
            $scope.status.selectedArray = $scope.status.selectedArray.length == $scope.appItems.length ? [] : [].concat($scope.appItems);
        };
        /**
         * [selectDoc description]单选
         * @params [{}] [description]
         * @return null [description]
         */
        $scope.selectDoc = function(appItem) {
            if ($scope.status.selectedArray.indexOf(appItem) < 0) {
                $scope.status.selectedArray.push(appItem);
            } else {
                $scope.status.selectedArray.splice($scope.status.selectedArray.indexOf(appItem), 1);
            }
        };
        // function initChannel() {
        //     $scope.params.serviceid = "mlf_mediasite";
        //     $scope.params.methodname = "getBroChannels";
        //     $scope.params.ChannelId = $stateParams.channel;
        //     requestData().then(function(data) {
        //         $scope.channels = data;
        //         var array = $scope.channels.pop();
        //         $scope.channels.unshift(array);
        //     });
        // };
        /**
         * [addChildren description] 新增子站点
         */
        $scope.addChildren = function(channel) {
            var column = {
                title: "新增子栏目",
                isColumn: true
            };
            addColumn(column, channel, function() {});
        };
        /**
         * [addColumn description]
         */
        function addColumn(column, channel, successFn) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/app/channel/template/channel_modify_tpl.html",
                windowClass: 'productManageMent-app-channel-modify',
                backdrop: false,
                controller: "appcolumnModifyCtrl",
                resolve: {
                    column: function() {
                        return column;
                    },
                    successFn: function() {
                        return successFn;
                    },
                    appChannel: function() {
                        return "";
                    },
                    selfChannel: function() {
                        return channel;
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                $scope.params = result;
                $scope.params.serviceid = "mlf_appconfig";
                $scope.params.methodname = "saveNewChnl";
                $scope.params.TopChannelId = '0';
                $scope.params.CHNLDATAPATH = result.DATAPATH;
                requestData().then(function() {
                    modalDialog.alertType(column.title + '成功', "", "success", false, function() {});
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
            });
        }

        function initChannel() {
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: "getBroChannels",
                ChannelId: $stateParams.channel
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.channels = data;
                var array = $scope.channels.pop();
                $scope.channels.unshift(array);
            });
        }
        //栏目移动弹窗
        // $scope.moveViews = function() {
        //     productMangageMentAppService.singleChooseChnl("移动栏目", $stateParams.site, $scope.selectedColumn.CHANNELID, function(data) {
        //         delete $scope.params.ChannelId;
        //         if (angular.isDefined(data.CHANNELID)) {
        //             $scope.params.ChannelId = data.CHANNELID;
        //             $scope.targetDesc = data.CHNLDESC;
        //         } else {
        //             $scope.targetDesc = data.SITEDESC;
        //         }
        //         $scope.params.SiteId = $stateParams.site;
        //         $scope.params.serviceid = "mlf_appconfig";
        //         $scope.params.methodname = "moveToBaseChannel";
        //         $scope.params.FromChnlId = $scope.selectedColumn.CHANNELID;
        //         $scope.params.TopChannelId = $stateParams.parentchnl;
        //         requestData().then(function(data) {
        //             $rootScope.$broadcast("leftAddAppColum", true);
        //             modalDialog.alertType("栏目移动成功", "该栏目成功移动到" + $scope.targetDesc, "success", false, function() {
        //                 $scope.params.serviceid = "mlf_appconfig";
        //                 $scope.params.methodname = "queryChannelsByChannelForCloud";
        //                 $scope.params.ChannelId = $stateParams.channel;
        //                 requestData().then(function(data) {
        //                     $scope.appItems = data;
        //                 });
        //             });
        //         });
        //     });
        // };
        //删除弹窗
        /**
         * [batDelete description] 批量删除方法
         * @return {[type]} [description]
         */
        $scope.batDelete = function() {
            if ($scope.status.selectedArray.length == 0) {
                modalDialog.alertType("请先选择一个栏目", "", "warning", false);
                return;
            } else {
                modalDialog.alertType("确定要删除选中的栏目吗", "", "warning", true, function() {
                    $scope.delete($scope.status.selectedArray);
                });
            }

        };
        $scope.delete = function(chnl) {
            $scope.data.selectChannelIds = trsspliceString.spliceString(chnl, "CHANNELID", ",");
            var ckConditionParamas = {
                serviceid: "mlf_appconfig",
                methodname: "checkChannelCondition",
                ChannelIds: $scope.data.selectChannelIds
            };
            var deleteParams = {
                serviceid: "mlf_appconfig",
                methodname: "RemoveChannels",
                ChannelIds: $scope.data.selectChannelIds,
                TopChannelId: '0',
                PassWord: ""
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), ckConditionParamas, "get")
                .then(function(data) {
                    productMangageMentAppService.inputPassword(function(password) {
                        LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                            deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "get")
                                .then(function(data) {
                                    modalDialog.alertType("删除成功", "", "success", false);
                                    $state.go($state.current.name, $stateParams, { reload: true });
                                });
                        });
                    });
                });
        };
        /**
         * [enableDisable description]启用停用栏目
         * @return null [description]
         */
        $scope.enableDisable = function(appItem) {

            if (appItem.STATUS === '0') {
                $scope.disableChannel(appItem);
            } else {
                $scope.reductionViews(appItem);
            }
        };
        /**
         * [disableChannel description]停用栏目
         * @return null [description]
         */
        $scope.disableChannel = function(appItem) {
            var checkParams = {
                serviceid: "mlf_appconfig",
                methodname: "deleteChannelCondition",
                ChannelId: appItem.CHANNELID,
                TopChannelId: '0'
            };
            var deleteParams = {
                serviceid: "mlf_appconfig",
                methodname: "deleteChannel",
                ChannelId: appItem.CHANNELID,
                TopChannelId: '0'
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), checkParams, "post")
                .then(function(data) {
                    modalDialog.inputModel("停用", "停用原因（选填）", function(data) {
                        productMangageMentAppService.inputPassword(function(password) {
                            LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                                deleteParams.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), deleteParams, "post")
                                    .then(function(data) {
                                        modalDialog.alertType("停用栏目成功", "", "success", false, function() {
                                            initData();
                                        });

                                    });
                            });
                        });
                    });

                });
        };
        /**
         * [reductionViews description]启用栏目
         * @params [{appItem}] [description] 栏目信息
         * @return null [description]
         */
        $scope.reductionViews = function(appItem) {
            modalDialog.alertType("确定启用该栏目？", "", "ask", true, function(data) {
                var reSiteParams = {
                    serviceid: "mlf_appconfig",
                    methodname: "restoreChannels",
                    ObjectIds: appItem.CHANNELID,
                    SiteId: $stateParams.site,
                    TopChannelId: '0',
                    RestoreAll: false
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), reSiteParams, "post")
                    .then(function(data) {
                        modalDialog.alertType("启用成功", "", "success", false, function() {
                            initData();
                        });
                    });
            });
        };
        //修改弹窗
        $scope.modify = function(appChannel) {
            var column = {
                title: "修改栏目",
                isColumn: true
            };
            $scope.modifyViews(column, function(data) {}, appChannel);
        };
        //新增弹窗
        $scope.add = function() {
            var column = {
                title: "新增栏目",
                isColumn: true
            };
            $scope.modifyViews(column, function(data) {}, "");
        };
        //发布栏目
        $scope.publish = function(appItem) {
            websiteService.websitePublish(appItem.CHANNELID, "101");
        };
        //修改弹窗方法
        $scope.modifyViews = function(column, successFn, appChannel) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/productManageMent/app/channel/template/channel_modify_tpl.html",
                windowClass: 'productManageMent-app-channel-modify',
                backdrop: false,
                controller: "appcolumnModifyCtrl",
                resolve: {
                    column: function() {
                        return column;
                    },
                    successFn: function() {
                        return successFn;
                    },
                    appChannel: function() {
                        return appChannel;
                    },
                    selfChannel: function() {
                        return "";
                    }
                }
            });
            return modalInstance.result.then(function(result) {
                $scope.params = result;
                $scope.params.serviceid = "mlf_appconfig";
                $scope.params.methodname = "saveNewChnl";
                $scope.params.TopChannelId = $stateParams.parentchnl;
                $scope.params.CHNLDATAPATH = result.DATAPATH;
                requestData().then(function(data) {
                    modalDialog.alertType("", column.title + '成功', "success", false, function() {});
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
            });
        };
        //栏目预览
        $scope.preview = function(appItem) {
            websiteService.websiteChannelPreview(appItem);
        };
    }]);